export enum PartnerErrors {
    CAN_NOT_FIND = "We couldn't find your workspace.",
}
